/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import ProgramStep from "@shared/Program/ProgramStep/ProgramStep";
import {StepType} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";
import {CompletedBy} from "@shared/Program/CompletedBy";
import UserProfile from "@shared/Profile/UserProfile";


export default class TaskProgramStep extends ProgramStep{

	stepType: string = StepType.TASK


	constructor(name = "") {
		super(name);
	}

	reset(){
		this.completedByArray = []
		super.reset()
	}



	findCompletedForUi(uid: string): ?CompletedBy{
		console.log("findCompletedForUi: uid = ", uid)
		console.log("findCompletedForUi: this.completedByArray = ", this.completedByArray)
		let completedBy: ?CompletedBy = null;
		if(uid){
			for(let i = 0; i < this.completedByArray.length; ++i){
				let completedByLocal = this.completedByArray[i];
				if(completedByLocal.uid == uid){
					completedBy = completedByLocal;
					break;
				}
			}
		}
		return completedBy;
	}

	completedCount(): number{
		return this.completedByArray.length
	}

	isCompleted(): boolean{
		return this.completedByArray.length > 0
	}
	isCompletedBy(uid: string): boolean{
		return this.findCompletedForUi(uid) != null
	}
	addCompletedBy(userProfile: UserProfile){
		let completedBy = new CompletedBy(userProfile.id, new Date().getTime())
		this.completedByArray.push(completedBy);
		this.dateCompletedTs = new Date().getTime()
	}

	removeCompletedBy(uid: string): boolean{
		if(uid){
			for(let i = 0; i < this.completedByArray.length; ++i){
				let completedByLocal = this.completedByArray[i];
				if(completedByLocal.uid == uid){
					this.completedByArray.splice(i, 1);
					this.dateCompletedTs = null
					return true;
				}
			}
		}
		return false;
	}

	toggleCompletedBy(userProfile: UserProfile){
		if(this.isCompletedBy(userProfile.id)){
			this.removeCompletedBy(userProfile.id)
		} else {
			this.addCompletedBy(userProfile)
		}
	}


}



